import React from 'react'
import type { InjectedColorProps } from 'react-color'
import { CustomPicker } from 'react-color'
import { Alpha, Hue, Saturation } from 'react-color/lib/components/common'
import type { ColorWrapChangeHandler } from 'react-color/lib/components/common/ColorWrap'

import { preventDefault } from 'constants/commonConstans'

import HexFields from './HexFields'
import * as s from './ReactColorPicker.module.scss'

type Props = InjectedColorProps & {
  onChange: ColorWrapChangeHandler
}

class ReactColorPicker extends React.Component<Props> {
  render() {
    const props = { ...this.props, radius: 6, pointer: () => <div className={s.sliderPointer} /> }
    const { onChange, hex, rgb } = this.props

    return (
      <div className={s.root}>
        <div className={s.saturation} onMouseDown={preventDefault}>
          <Saturation
            {...this.props}
            pointer={() => <div className={s.saturationPointer} style={{ backgroundColor: hex }} />}
          />
        </div>
        <div className={s.body}>
          <div className={s.hue}>
            <Hue {...props} />
          </div>
          <div className={s.alpha}>
            <Alpha {...props} />
          </div>
          <HexFields alpha={rgb?.a} hex={hex} onChange={onChange} />
        </div>
      </div>
    )
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default CustomPicker(ReactColorPicker as any)
